export enum SearchType {
  rep = 'Rep',
  group = 'Group',
  carrier = 'Carrier',
  customer = 'Customer',
  facility = 'Facility',
  load = 'Load',
}
